import React, { useEffect, ReactElement } from "react";

import { onSnapshotGeneralSettings } from "../../apis/firebase";

import { useDispatch } from "react-redux";

import { generalSettingRedux } from "../../redux";

let snapshotRef = null;

export default (): ReactElement => {
  const dispatcher = useDispatch();

  useEffect(() => {
    snapshotRef = onSnapshotGeneralSettings((data) => {
      dispatcher(
        generalSettingRedux.actions.updateGeneralSettings({
          ...data,
        })
      );
    });

    return () => snapshotRef();
  }, []);

  return <></>;
};
